<mat-card *ngIf="canView" class="progress-section">
    <div class="progress-header">
        <h3 >Porcentaje de Ejecución Presupuestal:</h3>
        <span class="progress-percentage" [style.color]="'#111827'" [style.background]="progressGradient"
            [style.border]="'1px solid ' + progressColor">
            {{percentage | number:'1.2-2'}}%
        </span>
    </div>

    <mat-progress-bar class="progress-bar-large" mode="determinate" [value]="percentage"
        [style.--progress-color]="progressColor">
    </mat-progress-bar>
</mat-card>